import { render, staticRenderFns } from "./DepositDetail.vue?vue&type=template&id=0383e382&scoped=true"
import script from "./DepositDetail.vue?vue&type=script&lang=js"
export * from "./DepositDetail.vue?vue&type=script&lang=js"
import style0 from "./DepositDetail.vue?vue&type=style&index=0&id=0383e382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383e382",
  null
  
)

export default component.exports